"use client";

import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { Menu } from "@/lib/bagisto/types";
import { Menu as MenuIcon, X } from "lucide-react";
import { useState } from "react";
import Link from "next/link";
// import { useSession } from "next-auth/react";
import { isObject } from "@/lib/type-guards";
import ThemeSwitch from "./theme-switch";

interface MenuItem {
  id: string;
  path: string;
  title: string;
}

interface MobileMenuProps {
  menu: MenuItem[];
  renderIcons: () => React.ReactNode;
}

export default function MobileMenu({ menu, renderIcons }: MobileMenuProps) {
  const [isOpen, setIsOpen] = useState(false);
  // const { data: session } = useSession();

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        aria-label="Open mobile menu"
        className="flex h-9 w-9 items-center justify-center"
      >
        <MenuIcon className="h-6 w-6"/>
      </button>

      <Sheet open={isOpen} onOpenChange={setIsOpen}>
        <SheetContent side="right" className="flex flex-col bg-white" hideCloseButton>
          <VisuallyHidden>
            <SheetTitle>Menu</SheetTitle>
          </VisuallyHidden>
          <SheetHeader className="flex w-full flex-row items-center justify-between">
            <button
              className="flex h-9 w-9 items-center justify-center rounded-lg border border-stroke text-neutral-900"
              onClick={() => setIsOpen(false)}
              aria-label="Close mobile menu"
            >
              <X className="h-6 w-6" />
            </button>
          </SheetHeader>

          {/* Menu links */}
          <div>
            {menu.length ? (
              <ul className="flex w-full flex-col">
                {menu.map((item) => (
                  <li
                    className="p-3 text-lg text-neutral-900 border-b border-stroke font-oswald font-medium uppercase hover:text-primary transition-colors"
                    key={item.id + item.title}
                  >
                    <Link href={item.path} onClick={() => setIsOpen(false)}>
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            ) : null}
          </div>

          {/* Icons */}
          <div className="flex items-center justify-center gap-6 py-2 bg-background-50 rounded-full">
            {renderIcons()}
          </div>

          {/* <SheetFooter>
            {isObject(session?.user) ? (
              <button
                onClick={() => setIsOpen(false)}
                className="h-12 w-full cursor-pointer rounded-full bg-neutral-900 text-white transition-colors hover:bg-neutral-700"
              >
                Log Out
              </button>
            ) : (
              <Link className="w-full" href="/customer/login">
                <button
                  onClick={() => setIsOpen(false)}
                  className="h-12 w-full cursor-pointer rounded-full bg-primary text-white transition-colors hover:bg-primary-600"
                >
                  Log In
                </button>
              </Link>
            )}
          </SheetFooter> */}
        </SheetContent>
      </Sheet>
    </>
  );
}
